package com.evoapps.evoshift.ui.adaptive

import androidx.compose.foundation.HorizontalScrollbar
import androidx.compose.foundation.ScrollState
import androidx.compose.foundation.ScrollbarStyle
import androidx.compose.foundation.VerticalScrollbar
import androidx.compose.foundation.background
import androidx.compose.foundation.lazy.LazyListState
import androidx.compose.foundation.rememberScrollbarAdapter
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.unit.dp

/** SH-169 / SH-208: Compose's scrollbars in the web (SH-208: the canvas has no scrollbars of its own), in the app's colours ([ScrollbarLook]). */
@Composable
private fun appScrollbarStyle() = ScrollbarStyle(
    minimalHeight = 32.dp,
    thickness = ScrollbarLook.Thickness,
    shape = RoundedCornerShape(ScrollbarLook.Thickness / 2),
    hoverDurationMillis = 200,
    unhoverColor = ScrollbarLook.Thumb,
    hoverColor = ScrollbarLook.ThumbHovered
)

@Composable
actual fun ListVerticalScrollbar(state: LazyListState, modifier: Modifier) {
    // Only while the list is longer than its window (no empty band on a short list).
    if (!state.canScrollForward && !state.canScrollBackward) return
    VerticalScrollbar(
        rememberScrollbarAdapter(state),
        modifier.background(ScrollbarLook.Track).testTag(ScrollbarTags.VERTICAL),
        style = appScrollbarStyle()
    )
}

@Composable
actual fun RowHorizontalScrollbar(state: ScrollState, modifier: Modifier) {
    // Only while the row is wider than its window (Int.MAX_VALUE: not measured yet).
    if (state.maxValue <= 0 || state.maxValue == Int.MAX_VALUE) return
    HorizontalScrollbar(
        rememberScrollbarAdapter(state),
        modifier.background(ScrollbarLook.Track).testTag(ScrollbarTags.HORIZONTAL),
        style = appScrollbarStyle()
    )
}
